export default __webpack_public_path__ + "static/media/tumorChannel5.a4a91fe4.png";